export interface BridgePage {
  id: string;
  tenant_id: string;
  slug: string;
  title: string;
  headline: string;
  headline_text?: string | null;
  subheadline?: string | null;
  button_text: string;
  button_color?: string;
  background_theme?: string;
  meta_capi_token?: string | null;
  timer_seconds: number;
  meta_pixel_id?: string | null;
  target_group_id?: string | null;
  target_group_name?: string | null;
  show_showcase_link?: boolean;
  theme_preference?: 'system' | 'light' | 'dark';
  is_active: boolean;
  total_views: number;
  total_conversions: number;
  conversion_rate: number;
  created_at: string;
  updated_at: string;
}

export interface BridgePageCreatePayload {
  title: string;
  slug: string;
  headline: string;
  headline_text?: string;
  subheadline?: string;
  button_text?: string;
  button_color?: string;
  background_theme?: string;
  meta_capi_token?: string;
  timer_seconds?: number;
  meta_pixel_id?: string;
  target_group_id?: string | null;
  show_showcase_link?: boolean;
  theme_preference?: 'system' | 'light' | 'dark';
  is_active?: boolean;
}

export interface BridgePageUpdatePayload {
  title?: string;
  slug?: string;
  headline?: string;
  headline_text?: string;
  subheadline?: string;
  button_text?: string;
  button_color?: string;
  background_theme?: string;
  meta_capi_token?: string;
  timer_seconds?: number;
  meta_pixel_id?: string;
  target_group_id?: string | null;
  show_showcase_link?: boolean;
  theme_preference?: 'system' | 'light' | 'dark';
  is_active?: boolean;
}

const API_BASE = '/api/bridge-pages';

export async function fetchBridgePages(token: string): Promise<BridgePage[]> {
  const res = await fetch(API_BASE, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.detail || 'Falha ao buscar páginas ponte');
  }
  return res.json();
}

export async function createBridgePage(
  token: string,
  payload: BridgePageCreatePayload
): Promise<BridgePage> {
  const res = await fetch(API_BASE, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.detail || 'Falha ao criar página ponte');
  }
  return res.json();
}

export async function updateBridgePage(
  token: string,
  id: string,
  payload: BridgePageUpdatePayload
): Promise<BridgePage> {
  const res = await fetch(`${API_BASE}/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.detail || 'Falha ao atualizar página ponte');
  }
  return res.json();
}

export async function toggleBridgePageStatus(
  token: string,
  id: string
): Promise<BridgePage> {
  const res = await fetch(`${API_BASE}/${id}/toggle-status`, {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.detail || 'Falha ao alterar status da página ponte');
  }
  return res.json();
}

export async function deleteBridgePage(
  token: string,
  id: string
): Promise<{ success: boolean; message: string }> {
  const res = await fetch(`${API_BASE}/${id}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.detail || 'Falha ao excluir página ponte');
  }
  return res.json();
}
